module.exports = __webpack_public_path__ + "img/bano.73651690.svg";